import { http } from '../../config/axios'

export default function getTipoParametroAplicacao(): Promise<any> {
  return http
    .get('api/parametroaplicacao/tipoparametro')
    .then((res) => {
      return res.data as any
    })
    .catch((error) => {
      console.error('Erro getTipoParametroAplicacao', error)
      throw Error(error.response.data)
    })
}
